
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comics/[activitySlug]",
      function () {
        return require("private-next-pages/comics/[activitySlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comics/[activitySlug]"])
      });
    }
  